module.exports = __webpack_public_path__ + "img/icon_con_di.8bc3308b.png";